export default __webpack_public_path__ + "static/media/hint-dog.86405df9.svg";